import React, {memo} from 'react';
import PropTypes from 'prop-types';

const NumberOfProductsColumn = memo(({feedExport, projectState}) => (
    <td className="pt-4">
      {Intl.NumberFormat(projectState.locale.replace('_', '-')).format(feedExport.last_exported) + ' '}
      <small>({Intl.NumberFormat(projectState.locale.replace('_', '-')).format(feedExport.last_total)})</small>
    </td>
  )
);

NumberOfProductsColumn.propTypes = {
  feedExport: PropTypes.object.isRequired,
  projectState: PropTypes.object.isRequired,
};

export default NumberOfProductsColumn;
